module.exports = __webpack_public_path__ + "assets/img/Earlytrade-Website-w720.4855dfe0.webp";